function e({keyArea:e=""}={}){var r=()=>({get(){},set(){}});return r.keyArea=e,r.noop=!0,r}e.factory=!0;export{e as nil};
//# sourceMappingURL=index.js.map
